import SystemAlert from './SystemAlert';

export default SystemAlert;
